import React from 'react';
import ExpandButtonWithText from '../../../common/ExpandButtonWithText';
import { useState } from 'react';
import './EditMetadataRow.css';
import { useEffect } from 'react';
export const EditMetadataRow = (props) => {
    const { text, searchValue, children } = props;

    const [isExpanded, setIsExpended] = useState(false);
    useEffect(() => {
        setIsExpended(searchValue ? true : false);
    }, [searchValue])
    const onClick = (e) => {
        setIsExpended(isExpanded => !isExpanded);
    }
    return <div name='EditMetadataRow'>
        <ExpandButtonWithText isExpanded={isExpanded} text={text} onClick={onClick} reverse={true} />
        {isExpanded ? children : null}
    </div>
}